import { forwardRef } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./IconButton.css";

export type IconButtonVariant = "ghost" | "solid" | "soft";
export type IconButtonSize = "sm" | "md";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  icon: ReactNode;
  /**
   * Required: an icon-only control has no text content, so without this the
   * button has no accessible name at all. Doubles as `title` for a mouse
   * tooltip so sighted and screen-reader users get the same information.
   */
  label: string;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, label, variant = "ghost", size = "md", className, ...rest },
  ref
) {
  const classes = ["ui-icon-btn", `ui-icon-btn--${variant}`, `ui-icon-btn--${size}`, className ?? ""]
    .filter(Boolean)
    .join(" ");

  return (
    <button ref={ref} type="button" className={classes} aria-label={label} title={label} {...rest}>
      {icon}
    </button>
  );
});
